import {Auth} from 'aws-amplify'
import axios from 'axios'

export default {
  mounted() {},
  methods: {
    async createCell(notebookId, graphId) {
      const param = {
        GraphId: graphId,
      }
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + `/mynotebooks/${notebookId}/cells`,
          param,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async createNotebook() {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks',
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deleteNotebook(notebookId) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks/' + notebookId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deleteRegisteredCell(notebookId, cellId) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT +
            '/mynotebooks/' +
            notebookId +
            '/cells/' +
            cellId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getCellById(notebookId, cellId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT +
            '/mynotebooks/' +
            notebookId +
            '/cells/' +
            cellId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getMyNotebooks(type) {
      let items = []
      const LIMIT = 500
      const params = {
        limit: LIMIT,
      }
      if (type === 'archives') {
        params.archived = true
      }
      if (type === 'share') {
        params.shared = true
      }
      if (type === 'public') {
        params.public = true
      }
      try {
        let offset = 0
        while (true) {
          params.offset = offset
          const result = await axios.get(
            process.env.VUE_APP_API_ENDPOINT + '/mynotebooks',
            {
              headers: {
                Authorization: (await Auth.currentSession()).getIdToken()
                  .jwtToken,
              },
              params: params,
            }
          )
          items = items.concat(result.data.Items)
          if (result.data.Items.length >= LIMIT) {
            offset += LIMIT
          } else {
            break
          }
        }
        return items
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getMyNotebook(itemId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks/' + itemId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getGraphTypes() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks/graph_types/',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getGraphTypesById(graphId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT +
            '/mynotebooks/graph_types/' +
            graphId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async generateGraph(notebookId, cellId, groups, parameters) {
      try {
        const param = {
          Groups: groups,
          Parameters: parameters,
        }
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT +
            '/mynotebooks/' +
            notebookId +
            '/cells/' +
            cellId,
          param,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async patchCell(notebookId, cellId, attributeName, attributeValue) {
      try {
        const param = {}
        param[attributeName] = attributeValue
        const result = await axios.patch(
          process.env.VUE_APP_API_ENDPOINT +
            '/mynotebooks/' +
            notebookId +
            '/cells/' +
            cellId,
          param,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async patchMyNotebooks(notebookId, attributeName, attributeValue) {
      try {
        const result = await axios.patch(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks/' + notebookId,
          {
            [attributeName]: attributeValue,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async restoreNotebook(notebookId) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT +
            '/mynotebooks/archives/restore/' +
            notebookId,
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getSharedOfNotebook(notebookId) {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks/share/' + notebookId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async postShareOfNotebook(notebookId, param) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks/share/' + notebookId,
          param,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        // This error is handled by parent function.
        throw error
      }
    },
    async postPublishOfNotebookV2(itemId) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + `/mynotebooks/public/${itemId}`,
          null,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deleteShareOfNotebook(notebookId, email) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + '/mynotebooks/share/' + notebookId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
            params: {
              email: email,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
  },
}
